<template>
  <div class="onetest" v-if="fourItem">
    <h2>{{fourItem.name }}</h2>
    <div v-for="(obj,index) in fourItem.list" :key="index" class="topicBox">
      <div class="topicBox_big" v-if="!obj.special && !obj.lastVoice">
        <div class="topicBox_1">
          <div v-if="obj.picture" class="picturePlace">({{obj.picture}})</div>
          <div>{{obj.name}}</div>
        </div>

        <div class="checkboxS">
          <div class="checkboxS_box">
            <div v-if="obj.question" class="checkboxS_box_1" style="text-align: center">
              计 分
              <div class="checkboxS_box_1_2">受测反应</div>
            </div>
            <el-radio-group v-model="obj.grade">
              <el-radio :label="1">1</el-radio>
              <el-radio :label="2">0</el-radio>
              <el-radio :label="3">无反应</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class v-if="obj.special && !obj.reword ">
        <div class="topicBox_1">
          <div>
            <div v-if="obj.picture" class="picturePlace">({{obj.picture}})</div>
            <div>{{obj.name}}</div>
          </div>
          <div v-if="obj.name2" class="topicBox_1_name2">{{obj.name2}}</div>
        </div>

        <div v-for="(objZoo,index) in obj.zooList" :key="index" class="objZooScss">
          <div class="fontSize">{{objZoo.name}}</div>
          <el-radio-group v-model="objZoo.grade">
            <el-radio :label="1">1</el-radio>
            <el-radio :label="2">0</el-radio>
            <el-radio :label="3">无反应</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class v-if="obj.reword && obj.special">
        <div class="topicBox_1">
          <div>
            <div v-if="obj.picture" class="picturePlace">({{obj.picture}})</div>
            <div>{{obj.name}}</div>
          </div>
          <div
            v-for="(objName,index) in obj.nameList"
            :key="index"
            class="topicBox_1_nameList"
          >{{objName}}</div>
          <div v-if="obj.name2" class="topicBox_1_name2">{{obj.name2}}</div>
        </div>

        <div v-for="(objZoo,index) in obj.zooList" :key="index" class="objZooScss">
          <div class="fontSize" v-html="objZoo.name"></div>
          <el-radio-group v-model="objZoo.grade">
            <el-radio :label="1">1</el-radio>
            <el-radio :label="2">0</el-radio>
            <el-radio :label="3">无反应</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="lastVoice">
      {{fourItem.nameAll}}
      <el-form ref="form" class="form" :model="form" label-width="10px">
        <el-form-item>
          <el-input v-model="fourItem.grade" :disabled="true"></el-input>
        </el-form-item>
      </el-form>分
    </div>
  </div>
</template>

<script>
export default {
  name: "onetest",
  components: {},
  props: {
    fourItem: {}
  },
  data() {
    return {
      form: {
        name: ""
      }
    };
  },
  created() {},
  mounted() {
    this.TopscrollTop();
  },
  watch: {
    "fourItem.list": {
      handler(newVal) {
        this.filterVal(newVal);
      },
      // immediate: true,
      deep: true
    }
  },
  computed: {},
  methods: {
    TopscrollTop() {
      document.querySelector(".onetest").scrollTo(0, 0);
    },
    filterVal(newVal) {
      // if (newVal.grade) return;
      let arr = newVal.map(item => {
        return (
          item.grade || (item.zooList && item.zooList.map(obj => obj.grade))
        );
      });
      if (arr) {
        let result = [];
        result = arr.flat().filter(res => res == 1);
        if (result) {
          this.fourItem.grade = JSON.parse(JSON.stringify(result.length));
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.topicBox {
  font-size: 20px;
  margin: 50px;

  .topicBox_big {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .topicBox_1 {
    display: flex;
    flex-direction: column;
    .topicBox_1_name2 {
      margin: 30px;
      margin-bottom: 0;
    }
    .topicBox_1_nameList {
      margin: 10px;
    }
  }
}

.checkboxS {
  display: flex;
  margin-left: 200px;
  .checkboxS_box {
    margin-left: 50px;
    .checkboxS_box_1 {
      display: flex;
      justify-content: center;
      .checkboxS_box_1_2 {
        margin-left: 30px;
      }
    }
  }
}
.objZooScss {
  //   margin: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .fontSize {
    margin-left: 30px;
    margin-top: 30px;
  }
}
.lastVoice {
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  line-height: 2;
  .form {
    border-bottom: 1px solid black;
  }
}
::v-deep .lastVoice {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-input .el-input__inner,
  .el-input.is-disabled .el-input__inner {
    background-color: transparent;
    border: none;

    font-size: 20px;
  }
}
</style>